import { useTranslation } from 'react-i18next';
import type { DateRange } from 'react-day-picker';

import { DateRangePicker } from '@/components/ui/date-range-picker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface Props {
  range: DateRange;
  onRangeChange: (range: DateRange) => void;
  currency: string;
  availableCurrencies: string[];
  onCurrencyChange: (currency: string) => void;
}

export function PromotionAnalyticsFilters({
  range,
  onRangeChange,
  currency,
  availableCurrencies,
  onCurrencyChange,
}: Props) {
  const { t } = useTranslation('analytics');

  return (
    <div className="flex flex-wrap items-center gap-2">
      <DateRangePicker value={range} onChange={onRangeChange} timezone="UTC" />

      {availableCurrencies.length > 1 && (
        <Select value={currency || undefined} onValueChange={onCurrencyChange}>
          <SelectTrigger className="h-9 w-[110px]">
            <SelectValue placeholder={t('promotionAnalytics.currency')} />
          </SelectTrigger>
          <SelectContent>
            {availableCurrencies.map((c) => (
              <SelectItem key={c} value={c}>
                {c}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
